export default __webpack_public_path__ + "assets/images/news-thumb.d6b31ce2.png";